__turbopack_context__.v({
  "accept": "CookiesBanner-module-scss-module__8NsO8a__accept",
  "banner": "CookiesBanner-module-scss-module__8NsO8a__banner",
  "bannerIOS": "CookiesBanner-module-scss-module__8NsO8a__bannerIOS",
  "bannerMobile": "CookiesBanner-module-scss-module__8NsO8a__bannerMobile",
  "learnMore": "CookiesBanner-module-scss-module__8NsO8a__learnMore",
  "reject": "CookiesBanner-module-scss-module__8NsO8a__reject",
});
